import React from 'react';

import { Button } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { useNavigate } from 'react-router-dom';

import { RuleTypes } from '../../../../constants/ruleTypes';
import { RuleViews } from '../../../../constants/ruleView';

const ReviewHistory = ({ isDraft, ruleType, view }: {
  isDraft: boolean;
  ruleType: RuleTypes;
  view: RuleViews;
}) => {
  const navigate = useNavigate();
  const action = isDraft ? 'RuleVersionPublish' : 'RuleVersionRelease';

  return (
    <Button
      startIcon={<HistoryIcon />}
      onClick={() => navigate(`/rules/reviews?action=${action}`, { state: { record: { ruleType, view } } })}
    >
      Review History
    </Button>
  );
};

export default ReviewHistory;
